import { ref } from 'vue';
import Client from "../services/client";
import Helpers from '../utils/helpers';

export const DEFAULT_SORT = {
    orderBy: 'date',
    order: 'desc'
}

export const POST_PER_PAGE = 21;

function useVideos () {
   const videos = ref([]);
   const loading = ref(false);
   const showMore = ref(false);

   async function doFetch (params) {
       loading.value = true;

       const fetchData = {
           page: 1,
           ...params,
       };

       try {
           const {data, headers} = await Client.get(
               `/wp-json/wp/v2/video/?${Helpers.encodeGetParams(fetchData, true)}`,
               {
                   headers: {"X-WP-Nonce": window.wp_nonce.nonce},
               }
           );

           videos.value = (data || []).map(video => ({
               ...video,
               contentSliced: video.content.rendered.split(" ").slice(0, 25).join(" ") + "...",
           }));

           showMore.value = headers["x-wp-totalpages"] > 1;
       } catch (e) {
           console.error(e);
       } finally {
           loading.value = false;
       }
   }

   return {
       videos,
       loading,
       showMore,
       doFetch
   }
}

export default useVideos;
